export default __webpack_public_path__ + "static/feature-dashboard-2ebc470cef58d63a00773e4d40d79e69.png";